import { useEffect } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import ReportTypeChooser from '../reports/ReportTypeChooser';
import useReportFilters from '../reports/hooks/useReportFilters';

export function ReportsPage() {
  const { theme } = useStyles();
  const { resetFilters } = useReportFilters();

  useEffect(() => {
    resetFilters(true);
  }, []);

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportTypeChooser />
        </FloatingCardContent>
      }
      contentSize={750}
    />
  );
}
